import { cn } from './cn'
import { Star } from './icons'

const stars = [1, 2, 3, 4, 5] as const

// The mockups fill stars with critical-main in light mode, but it is 2.7:1 on white, below the 3:1 a
// meaningful graphic needs (token-contrast.test.ts), so light mode uses its darker text shade.
const filledColor = 'text-critical-text dark:text-warning-text'

export interface StarRatingProps {
  /** Whole stars filled, 0 to 5. */
  readonly value: number
  /** The rating in words, such as "4 out of 5 stars", for assistive technology. */
  readonly label: string
  readonly className?: string
}

/** A read-only five-star rating; 0 is five empty stars. */
export function StarRating({ value, label, className }: StarRatingProps) {
  return (
    <div className={cn('flex items-center gap-0.5', className)}>
      <span className="sr-only">{label}</span>
      {stars.map((n) => (
        <Star
          key={n}
          size={16}
          filled={n <= value}
          className={n <= value ? filledColor : 'text-text-light'}
        />
      ))}
    </div>
  )
}
